import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, GiftIcon, BookOpenIcon, HeadphonesIcon, CheckSquareIcon, SparklesIcon, ZapIcon, CompassIcon, ShieldIcon } from 'lucide-react';
import { useGeoPrice } from '../hooks/useGeoPrice';
const PURCHASE_URL = 'https://pay.hotmart.com/R104430088E?bid=1770999394323';
export function ExitIntentPopup() {
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [ready, setReady] = useState(false);
  const {
    price,
    loading
  } = useGeoPrice();
  const displayPrice = loading ? '$27 USD' : price;
  // 7-second delay before popup can appear
  useEffect(() => {
    const readyTimer = setTimeout(() => setReady(true), 7000);
    return () => clearTimeout(readyTimer);
  }, []);
  const handleMouseLeave = useCallback((e: MouseEvent) => {
    if (e.clientY <= 5 && !dismissed && !show && ready) {
      setShow(true);
    }
  }, [dismissed, show, ready]);
  useEffect(() => {
    document.addEventListener('mouseleave', handleMouseLeave);
    return () => document.removeEventListener('mouseleave', handleMouseLeave);
  }, [handleMouseLeave]);
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!dismissed && !show && ready) {
        setShow(true);
      }
    }, 45000);
    return () => clearTimeout(timer);
  }, [dismissed, show, ready]);
  function handleDismiss() {
    setShow(false);
    setDismissed(true);
  }
  return <AnimatePresence data-id="element-98">
      {show && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-[60] flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label="Oferta especial antes de irte" data-id="element-99">
          <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={handleDismiss} data-id="element-100" />

          <motion.div initial={{
        scale: 0.95,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} exit={{
        scale: 0.95,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="relative bg-[#1a0b3b] border border-white/10 rounded-2xl max-w-md w-full p-6 md:p-8 shadow-2xl" data-id="element-101">
            <button onClick={handleDismiss} className="absolute top-4 right-4 text-gray-500 hover:text-white transition-colors" aria-label="Cerrar" data-id="element-102">
              <XIcon className="w-5 h-5" data-id="element-103" />
            </button>

            <div className="text-center mb-6" data-id="element-104">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-amber-500/10 mb-4" data-id="element-105">
                <GiftIcon className="w-6 h-6 text-amber-500" data-id="element-106" />
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-107">
                Espera — no te vayas sin esto
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-108">
                Esto es todo lo que te llevas hoy con el Super Pack:
              </p>
            </div>

            <div className="space-y-2.5 mb-6" data-id="element-109">
              <ExitItem icon={<BookOpenIcon className="w-4 h-4" data-id="element-111" />} text="Ebook — Guía completa" data-id="element-110" />
              <ExitItem icon={<HeadphonesIcon className="w-4 h-4" data-id="element-113" />} text="Audiolibro para reforzar cada día" data-id="element-112" />
              <ExitItem icon={<CheckSquareIcon className="w-4 h-4" data-id="element-115" />} text="Habit Tracker imprimible + digital" data-id="element-114" />
              <div className="pt-1 pb-1" data-id="element-116">
                <p className="text-amber-500/50 text-[10px] font-semibold uppercase tracking-widest px-4" data-id="element-117">
                  + 5 Bonos:
                </p>
              </div>
              <ExitItem icon={<SparklesIcon className="w-4 h-4" data-id="element-119" />} text="Frases de Poder" data-id="element-118" />
              <ExitItem icon={<CheckSquareIcon className="w-4 h-4" data-id="element-121" />} text="Habit Tracker Extra" data-id="element-120" />
              <ExitItem icon={<ZapIcon className="w-4 h-4" data-id="element-123" />} text="Reinicio Express — 7 Guiones" data-id="element-122" />
              <ExitItem icon={<CompassIcon className="w-4 h-4" data-id="element-125" />} text="Biblioteca de Señales — 21 Disparadores" data-id="element-124" />
              <ExitItem icon={<ShieldIcon className="w-4 h-4" data-id="element-127" />} text="Plan Anti-Abandono — 14 Días" data-id="element-126" />
            </div>

            <div className="text-center mb-4" data-id="element-128">
              <p className="text-gray-500 text-sm mb-1" data-id="element-129">Todo por solo</p>
              <div className="flex items-center justify-center gap-2 mb-1" data-id="element-130">
                <span className="text-gray-500 line-through text-lg" data-id="element-131">
                  $47.99 USD
                </span>
                <span className="bg-red-500/90 text-white text-[10px] font-black uppercase px-2 py-0.5 rounded-full" data-id="element-132">
                  -83%
                </span>
              </div>
              <p className="text-3xl font-bold text-white" data-id="element-133">$7.99 USD</p>
              <p className="text-amber-500/70 text-[11px] font-semibold mt-1" data-id="element-134">
                🔥 Super Promo — Solo por esta semana
              </p>
            </div>

            <a href={PURCHASE_URL} onClick={handleDismiss} className="cta-hero-glow block w-full bg-amber-500 hover:bg-amber-400 text-black text-center py-4 rounded-xl transition-colors mb-3" data-id="element-135">
              <span className="block font-black text-base" data-id="element-136">
                SUPER PROMO — $7.99 USD
              </span>
              <span className="block text-black/50 text-[10px] font-semibold mt-0.5" data-id="element-137">
                ⚡ Solo por esta semana
              </span>
            </a>

            <button onClick={handleDismiss} className="block w-full text-center text-gray-500 text-sm hover:text-gray-400 transition-colors py-2" data-id="element-138">
              No, prefiero seguir como estoy
            </button>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
function ExitItem({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex items-center gap-3 bg-white/[0.03] border border-white/5 rounded-lg px-4 py-2.5" data-id="element-139">
      <span className="text-amber-500 flex-shrink-0" data-id="element-140">{icon}</span>
      <span className="text-gray-300 text-sm" data-id="element-141">{text}</span>
    </div>;
}